import React from 'react';
import ChargingStationContainer from 'containers/ChargingStationTable';

const ChargingTable = (props) => {
  return  (
    <>
   <ChargingStationContainer {...props}/>
    </>
  );
};

export default ChargingTable;
